<template lang="pug">
div
  v-btn(small, text, color="secondary", @click="open()") Capture
  v-dialog(v-model="dialog", width="500")
    v-card
      v-card-title Capture
      v-form(@submit.prevent="load()")
        v-card-text
          v-text-field(v-model.number="amount", label="Amount (cent)")
          v-text-field(v-model="retref", label="Retref")
          v-text-field(v-model="authcode", label="Authcode")
          div(v-if="result")
            .subtitle-2 Result
            pre {{ result }}
        v-card-actions
          v-btn(color="primary", type="submit", :loading="loading") Submit
</template>

<script>
export default {
  props: {
    mid: { type: String, required: true },
    hsn: { type: String, required: true },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      amount: 1000,
      retref: "",
      authcode: "",
      result: null,
    };
  },
  methods: {
    open() {
      this.dialog = true;
    },
    async load() {
      if (!this.mid) return;
      this.loading = true;
      const params = {
        mid: this.mid,
        amount: this.amount,
        retref: this.retref,
        authcode: this.authcode,
      };
      try {
        this.result = await this.$api.cardpointe.cardconnect.capture(params);
      } catch (e) {
        this.$toast.error(e.response?.data || e.message);
      }
      this.loading = false;
    },
  },
};
</script>